// extracted by mini-css-extract-plugin
module.exports = {"root":"DropArea_root__2N69l"};